import React from 'react';
import { MessageCircle, Mail, Phone } from 'lucide-react';
import { Button } from './ui/button';

const CTA = () => {
  const handleTelegramClick = () => {
    window.open('https://t.me/AIchatbusinesbot', '_blank');
  };

  return (
    <section id="cta" className="py-16 sm:py-24 bg-gradient-to-br from-blue-600 via-blue-700 to-blue-800 text-white relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-10 left-10 w-72 h-72 bg-white rounded-full blur-3xl"></div>
        <div className="absolute bottom-10 right-10 w-96 h-96 bg-[#FFD700] rounded-full blur-3xl"></div>
      </div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-6">
            Готовы автоматизировать свой бизнес?
          </h2>
          <p className="text-lg sm:text-xl mb-8 text-blue-100">
            Запишитесь на бесплатную консультацию и узнайте, как AI-решения могут увеличить ваши продажи
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
            <Button 
              onClick={handleTelegramClick}
              className="bg-[#FFD700] hover:bg-[#E5C200] text-gray-900 font-bold text-lg px-8 py-6 shadow-xl hover:shadow-2xl transition-all"
            >
              <MessageCircle className="mr-2 w-6 h-6" />
              Написать в Telegram
            </Button>
            <Button 
              variant="outline" 
              className="bg-white/10 backdrop-blur-sm border-2 border-white text-white hover:bg-white hover:text-blue-700 font-semibold text-lg px-8 py-6 transition-all"
              onClick={() => window.location.href = 'mailto:info@dathent.com'}
            >
              <Mail className="mr-2 w-6 h-6" />
              Отправить email
            </Button>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 pt-8 border-t border-white/20">
            <div className="flex flex-col items-center">
              <MessageCircle className="w-12 h-12 mb-3 text-[#FFD700]" />
              <h3 className="font-bold text-lg mb-2">Telegram</h3>
              <a 
                href="https://t.me/AIchatbusinesbot" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-blue-100 hover:text-white transition-colors underline"
              >
                @AIchatbusinesbot
              </a>
            </div>
            <div className="flex flex-col items-center">
              <Mail className="w-12 h-12 mb-3 text-[#FFD700]" />
              <h3 className="font-bold text-lg mb-2">Email</h3>
              <a 
                href="mailto:info@dathent.com" 
                className="text-blue-100 hover:text-white transition-colors"
              >
                info@dathent.com
              </a>
            </div>
            <div className="flex flex-col items-center">
              <Phone className="w-12 h-12 mb-3 text-[#FFD700]" />
              <h3 className="font-bold text-lg mb-2">Телефон</h3>
              <a 
                href="tel:+34865443750" 
                className="text-blue-100 hover:text-white transition-colors"
              >
                +34 865 443 750
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTA;
